<template>
  <div class="dashboard">
    <div class="row" v-if="user !== null">
        <HomeItem title="Capteurs / Enquêtes" description="Prendre le pouls des managers et équipes" :img="require('@/assets/Capteur_5.svg')" link="/survey/"/>
        <HomeItem title="E-Learning" description="Apprendre à gérer la situtation" :img="require('@/assets/E_Learning_5.svg')" link="/elearning/"/>
        <HomeItem title="Toolkit" description="Garder le lien et motiver son équipe" :img="require('@/assets/Toolkit_5.svg')" link="/documentation/"/>
        <HomeItem title="Echanges" description="Développer le collectif managérial" :img="require('@/assets/Echange_5.svg')" link="/echanges/forum/"/>
        <HomeItem title="Coaching" description="Etre soutenu en tant que manager" :img="require('@/assets/Coaching_5.svg')" link="/coaching/"/>
        <div class="col-md-4 homeitem  mt-4 pl-4 pr-4">
            <a :href="link">
                <b-card no-body class="mb-2 full" v-if="!blank">
                    <b-card-body style="text-align:left;">
                        <h1>Actualité</h1>
                        <span style="text-align:left;">{{ pnew.content }}</span>
                    </b-card-body>
                </b-card>
            </a>
        </div>
    </div>
  </div>
</template>

<script>
  import HomeItem from '../components/HomeItem'
  import { mapState } from 'vuex';
  import {GET_PRIORITY_NEWS_REQUEST} from "../_store/exchange/actiontypes";
  export default {
    name: 'dashboard',
    components: { HomeItem },
    computed: mapState({ user: state => state.user.user,
        pnew: state => state.exchange.pnew
    }),
      mounted() {
          this.$store.dispatch(GET_PRIORITY_NEWS_REQUEST)
      },
    data() {
    },
    layout(context) {
      return 'layout'
    },
    methods: {
    },
  };
</script>
